import { getMallAppToken, getToken } from '@/utils/globalData'
let frontServiceUrl="/frontserver";
export function getCurrentLocaleTransferCode(locale) {
  const localeCode = String(locale || 'zh-CN').trim()
  const codeMap = {
    'en': 'en',
    'en-US': 'en',
    'vi': 'vi',
    'vi_VN': 'vi',
    'vi-VN': 'vi',
    'ja': 'ja',
    'jp': 'ja',
    'ja_JP': 'ja',
    'ja-JP': 'ja',
    'zh-TW': 'zh-tw',
    'zh-Hant': 'zh-tw',
    'tw': 'zh-tw',
  }

  if (codeMap[localeCode])
    return codeMap[localeCode]

  if (localeCode.toLowerCase().startsWith('zh'))
    return ''

  return localeCode
}

function normalizeTranslatedList(list) {
  if (!Array.isArray(list))
    return []

  return list.map((item) => {
    if (typeof item === 'string')
      return item
    return item?.translatedText
      || item?.targetText
      || item?.result
      || item?.text
      || item?.sourceText
      || ''
  })
}

function parseTranslateBatchTexts(res) {
  const payload = res?.data ?? res ?? {}
  const transferRes = payload?.result
  const transferResults = payload?.results || payload?.data?.results || []
  const transferData = payload?.data
  const transferListData = payload?.list
  const transferResultData = payload?.resultList

  if (Array.isArray(transferResults) && transferResults.length) {
    return transferResults
      .slice()
      .sort((a, b) => Number(a?.index || 0) - Number(b?.index || 0))
      .map(item => item?.translatedText || item?.targetText || item?.sourceText || '')
  }

  if (Array.isArray(transferData))
    return normalizeTranslatedList(transferData)

  if (Array.isArray(transferListData))
    return normalizeTranslatedList(transferListData)

  if (Array.isArray(transferResultData))
    return normalizeTranslatedList(transferResultData)

  if (typeof transferRes === 'string')
    return transferRes.split('\n')

  return []
}

function resolveTranslateFetcher(fetcher) {
  if (typeof fetcher === 'function')
    return fetcher

  if (typeof globalThis.$fetch === 'function')
    return globalThis.$fetch

  if (typeof globalThis.fetch === 'function') {
    return async (url, options = {}) => {
      const response = await globalThis.fetch(url, {
        ...options,
        body: options?.body ? JSON.stringify(options.body) : undefined,
      })
      return response.json()
    }
  }

  return null
}

export async function translateMallBatchTexts(options = {}) {
  const rawTexts = Array.isArray(options.texts) ? options.texts : []
  const texts = Array.from(
    new Set(
      rawTexts
        .map(item => String(item || '').trim())
        .filter(Boolean),
    ),
  )

  const targetLanguage = getCurrentLocaleTransferCode(options.targetLanguage)
  const translatedMap = {}

  if (!texts.length || !targetLanguage) {
    return {
      texts,
      targetLanguage,
      translatedTexts: [],
      translatedMap,
    }
  }

  const fetcher = resolveTranslateFetcher(options.fetcher)

  if (typeof fetcher !== 'function') {
    texts.forEach((text) => {
      translatedMap[text] = text
    })
    return {
      texts,
      targetLanguage,
      translatedTexts: texts.slice(),
      translatedMap,
    }
  }

  // /frontserver 是主站接口，优先使用主站 token；兼容旧页面时再回退商城 token。
  const authorizationCandidates = Array.from(new Set([
    options.authorization,
    getToken(),
    getMallAppToken(),
    '',
  ].filter(value => value !== undefined && value !== null)))

  for (let i = 0; i < texts.length; i += 100) {
    const chunk = texts.slice(i, i + 100)
    let translatedTexts = []

    for (const authorization of authorizationCandidates) {
      try {
        const headers = { 'Content-Type': 'application/json' }
        if (authorization)
          headers.authorization = authorization

        const res = await fetcher(frontServiceUrl+'/translate/batch?hiddenErrTip=1', {
          method: 'POST',
          headers,
          body: {
            isSystemText: typeof options.isSystemText === 'number' ? options.isSystemText : 0,
            texts: chunk,
            sourceLanguage: options.sourceLanguage || 'zh',
            targetLanguage,
            appType: options.appType || 'react-mall-app',
          },
        })

        if (res?.success === false || res?.data?.success === false)
          continue

        translatedTexts = parseTranslateBatchTexts(res)
        if (translatedTexts.length)
          break
      }
      catch {}
    }

    if (!translatedTexts.length) {
      chunk.forEach((text) => {
        translatedMap[text] = text
      })
      continue
    }

    chunk.forEach((text, index) => {
      translatedMap[text] = translatedTexts[index] || text
    })
  }

  return {
    texts,
    targetLanguage,
    translatedTexts: texts.map(text => translatedMap[text] || text),
    translatedMap,
  }
}
